import * as getters from './Getters'
import * as actions from './Actions'
import * as mutations from './Mutaions'

//Statelerimiz
const state = () => ({
    loading: false,
    customerStatus : {},
    customerData: {},
    customerAddressData: [],
    customerAddressInfo: {},
    customerContactData: [],
    customerContactInfo: {},
    customerCompanyData: [],
    customerCompanyInfo: {},
    customerPageInfo: {},
    customerSubscriptions: [],
    customerSubsInfo: {},
    customerProducts: [],
    customers:[],
    approvalHistory: []
})

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/Alarmsis/Customer/index.js